var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,null,{
      loading: _vm.loading,
      loadingConfig: _vm.loadingConfig,
      items: _vm.items,
      fields: _vm.fields,
      tableSortable: _vm.tableSortable,
      pagination: _vm.pagination,
      queryConfig: _vm.queryConfig,
      searchAndOrder: _vm.searchAndOrder,
      checkedAll: _vm.checkedAll,
      initialView: _vm.initialView,
      cardType: _vm.cardType,
      availableViews: _vm.availableViews,
      counterGetEntity: _vm.counterGetEntity,
      showTableHeader: _vm.showTableHeader,
      showTableTitlesRow: _vm.showTableTitlesRow,
      canLoadQueryParams: _vm.canLoadQueryParams,
      gridCols: _vm.gridCols,
      methods: {
        getEntities: _vm.getEntities,
        getConfig: _vm.getConfig,
        onCheckAll: _vm.onCheckAll,
        onCheckRow: _vm.onCheckRow,
        clearEntities: _vm.clearEntities,
        loadQueryParamsFromURL: _vm.loadQueryParamsFromURL,
        onChangeOrder: _vm.onChangeOrder,
      },
    })],2)}
var staticRenderFns = []

export { render, staticRenderFns }